// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-flow-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Reuse existing profiling styles */
.profiling-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.profiling-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 600px;
  width: 100%;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.profiling-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0877BC, #065a8f);
}

.profiling-header {
  text-align: center;
  margin-bottom: 40px;
}

.profiling-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #0877BC;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.success-icon {
  font-size: 40px;
  color: #27ae60;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.profiling-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #0877BC, #065a8f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.profiling-header p {
  font-size: 1.1rem;
  color: #718096;
  line-height: 1.6;
  margin-bottom: 8px;
}

.email-display {
  font-size: 1rem;
  color: #0877BC;
  font-weight: 600;
  background: rgba(8, 119, 188, 0.1);
  padding: 8px 16px;
  border-radius: 8px;
  display: inline-block;
  margin-top: 16px;
}

.profiling-form {
  width: 100%;
}

.input-field {
  margin-bottom: 24px;
}

.input-field label {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.input-field input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  color: #2d3748;
  background: #ffffff;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.input-field input:focus {
  outline: none;
  border-color: #0877BC;
  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);
}

.input-field input.error {
  border-color: #e53e3e;
  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.1);
}

.input-field input::placeholder {
  color: #a0aec0;
}

.error-message {
  color: #e53e3e;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 4px;
  display: block;
}

.general-error {
  background: #fed7d7;
  border: 1px solid #feb2b2;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: #c53030;
  font-weight: 500;
}

.profiling-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 32px;
}

.back-button {
  background: #f7fafc;
  color: #4a5568;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.back-button:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
  transform: translateY(-1px);
}

.next-button {
  background: linear-gradient(135deg, #0877BC, #065a8f);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 32px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  flex: 1 1;
  max-width: 200px;
  box-shadow: 0 4px 15px rgba(8, 119, 188, 0.3);
}

.next-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(8, 119, 188, 0.4);
}

.next-button:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  box-shadow: none;
}

.retry-button {
  background: #e53e3e;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.retry-button:hover {
  background: #c53030;
  transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .profiling-card {
    padding: 24px;
    margin: 10px;
  }

  .profiling-header h1 {
    font-size: 2rem;
  }

  .profiling-header p {
    font-size: 1rem;
  }

  .profiling-actions {
    flex-direction: column;
    gap: 12px;
  }

  .back-button,
  .next-button {
    width: 100%;
    max-width: none;
  }
}

@media (max-width: 480px) {
  .profiling-container {
    padding: 10px;
  }

  .profiling-card {
    padding: 20px;
  }

  .profiling-header h1 {
    font-size: 1.75rem;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/RegistrationFlow.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAA4D;AAC9D;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".registration-flow-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* Reuse existing profiling styles */\n.profiling-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.profiling-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  max-width: 600px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.profiling-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #0877BC, #065a8f);\n}\n\n.profiling-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.profiling-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #0877BC;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.success-icon {\n  font-size: 40px;\n  color: #27ae60;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.profiling-header h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin-bottom: 16px;\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.profiling-header p {\n  font-size: 1.1rem;\n  color: #718096;\n  line-height: 1.6;\n  margin-bottom: 8px;\n}\n\n.email-display {\n  font-size: 1rem;\n  color: #0877BC;\n  font-weight: 600;\n  background: rgba(8, 119, 188, 0.1);\n  padding: 8px 16px;\n  border-radius: 8px;\n  display: inline-block;\n  margin-top: 16px;\n}\n\n.profiling-form {\n  width: 100%;\n}\n\n.input-field {\n  margin-bottom: 24px;\n}\n\n.input-field label {\n  display: block;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.input-field input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  color: #2d3748;\n  background: #ffffff;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.input-field input:focus {\n  outline: none;\n  border-color: #0877BC;\n  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);\n}\n\n.input-field input.error {\n  border-color: #e53e3e;\n  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.1);\n}\n\n.input-field input::placeholder {\n  color: #a0aec0;\n}\n\n.error-message {\n  color: #e53e3e;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-top: 4px;\n  display: block;\n}\n\n.general-error {\n  background: #fed7d7;\n  border: 1px solid #feb2b2;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  color: #c53030;\n  font-weight: 500;\n}\n\n.profiling-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-top: 32px;\n}\n\n.back-button {\n  background: #f7fafc;\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 12px 24px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 120px;\n}\n\n.back-button:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n  transform: translateY(-1px);\n}\n\n.next-button {\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 12px 32px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 140px;\n  flex: 1;\n  max-width: 200px;\n  box-shadow: 0 4px 15px rgba(8, 119, 188, 0.3);\n}\n\n.next-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(8, 119, 188, 0.4);\n}\n\n.next-button:disabled {\n  background: #cbd5e0;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.retry-button {\n  background: #e53e3e;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 16px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.retry-button:hover {\n  background: #c53030;\n  transform: translateY(-1px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .profiling-card {\n    padding: 24px;\n    margin: 10px;\n  }\n\n  .profiling-header h1 {\n    font-size: 2rem;\n  }\n\n  .profiling-header p {\n    font-size: 1rem;\n  }\n\n  .profiling-actions {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .back-button,\n  .next-button {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .profiling-container {\n    padding: 10px;\n  }\n\n  .profiling-card {\n    padding: 20px;\n  }\n\n  .profiling-header h1 {\n    font-size: 1.75rem;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
